import { i18n } from '@lingui/core'
import 'intl-pluralrules'

import { messages as messagesEN } from './locales/en/messages'
import { messages as messagesDE } from './locales/de/messages'
import { messages as messagesFR } from './locales/fr/messages'

const locales = {
  en: messagesEN,
  de: messagesDE,
  fr: messagesFR,
}

const loadLocale = async (locale: string) => {
  let _locale = locale
  if (!Object.keys(locales).includes(locale)) {
    _locale = 'de' // Default to German
  }
  i18n.load(_locale, locales[_locale as keyof typeof locales])
  i18n.activate(_locale)
}

// Initialize with default locale for SSR
loadLocale('de')

export { i18n, loadLocale }

// Helper function to detect locale from request headers
export function getLocaleFromRequest(request: Request): string {
  const acceptLanguage = request.headers.get('accept-language')
  if (acceptLanguage) {
    // Parse Accept-Language header and find the best match
    const languages = acceptLanguage
      .split(',')
      .map((lang) => {
        const [language, quality = '1'] = lang.trim().split(';q=')
        return { language: language.split('-')[0], quality: parseFloat(quality) }
      })
      .sort((a, b) => b.quality - a.quality)

    for (const { language } of languages) {
      if (Object.keys(locales).includes(language)) {
        return language
      }
    }
  }
  return 'de' // Default fallback
}
